export default function isCurrentFile({ props, state, path }) {
  const currentFile = state.get('media.currentFile')
  const { id } = props.payload
  if (currentFile === `media.files.${id}`) {
    return path.true()
  }
  return path.false()
}



// WEBPACK FOOTER //
// ./src/modules/Socket/actions/isCurrentFile.js